module.exports = __webpack_public_path__ + "img/hot.4f0f0ad3.png";